(() => {
  const setProductGallerySwiper = () => {
    const secondary = new Swiper(".product-gallery__secondary-swiper", {
      slidesPerView: "auto",
      spaceBetween: 24,
      freeMode: true,
      watchSlidesProgress: true,
    });

    const main = new Swiper(".product-gallery__main-swiper", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".product-gallery-next",
        prevEl: ".product-gallery-prev",
      },
      thumbs: {
        swiper: secondary,
      },
    });
  };

  setProductGallerySwiper();

  const observer = new MutationObserver(() => {
    setProductGallerySwiper();
  });

  observer.observe(document.querySelector(".pdp__left-side"), {
    childList: true,
  });
})();
